import React, { useState } from "react";

import ProjectDetailsModal from "./ProjectDetailsModal";

import { useAppSelector } from "../../redux/hooks";
import { getAuthToken } from "../../redux/reducers/auth";

import { postCreateChatroom } from "../../services/api/chat/postCreateChatroom";
import { postRoomCreationFailedReport } from "../../services/api/user/postRoomCreationFailedReport";

import { useApplyProject } from "../../utils/useProject";
import { QueryKey } from "@tanstack/react-query";

export const enum ApplicationRequestState {
  Waiting,
  Doing,
  Success,
  applicationFailed,
  chatFailed,
}

type Props = {
  id?: string;
  projectTitle?: string;
  ownerId: string;
  ownerName: string;
  ownerChatDenial: boolean;
  refetchKey: QueryKey;
  handleClose: () => void;
  question?: string;
};

const ProjectDetailsModalContainer: React.FC<Props> = ({
  id,
  projectTitle,
  ownerId,
  ownerName,
  ownerChatDenial,
  refetchKey,
  handleClose,
  question,
}) => {
  const auth_token = useAppSelector(getAuthToken);

  const { mutateAsync } = useApplyProject(refetchKey);

  const [requestState, setRequestState] = useState<ApplicationRequestState>(
    ApplicationRequestState.Waiting
  );

  const [message, setMessage] = useState<string>("");

  const handleInputChange = (value: string) => {
    setMessage(value);
  };

  const handleSubmit = async () => {
    if (!auth_token || !id) return;

    setRequestState(ApplicationRequestState.Doing);

    const res = await mutateAsync({
      auth_token: auth_token,
      id: id,
      message: message,
    });

    if (!res) return setRequestState(ApplicationRequestState.applicationFailed);

    const chatRes = await postCreateChatroom(
      auth_token,
      ownerId,
      "project",
      id
    );

    if (!chatRes) {
      postRoomCreationFailedReport("project/application", res);
      return setRequestState(ApplicationRequestState.chatFailed);
    }

    setRequestState(ApplicationRequestState.Success);
  };

  return (
    <ProjectDetailsModal
      projectTitle={projectTitle}
      ownerName={ownerName}
      ownerChatDenial={ownerChatDenial}
      handleClose={() => {
        handleClose();
        setRequestState(ApplicationRequestState.Waiting);
      }}
      handleSubmit={handleSubmit}
      handleInputChange={handleInputChange}
      question={question}
      requestState={requestState}
    />
  );
};

export default ProjectDetailsModalContainer;
